export const PALETTE = {
    dark: {
        gray: { text: '#C0BFCA', background: '#28282C' },
        brown: { text: '#E1B79C', background: '#36251C' },
        orange: { text: '#FFCB8B', background: '#382F23' },
        yellow: { text: '#C5BC66', background: '#2B2611' },
        green: { text: '#8ADBAD', background: '#182F22' },
        blue: { text: '#9ED6FF', background: '#2D3441' },
        purple: { text: '#D5B0FF', background: '#312B3E' },
        pink: { text: '#FFA9D2', background: '#35282F' },
        red: { text: '#FFBAB5', background: '#482827' },
    },
    light: {
        gray: { text: '#5C5B63', background: '#E6E6EB' },
        brown: { text: '#785134', background: '#F3E4DC' },
        orange: { text: '#8C5701', background: '#FEE1CA' },
        yellow: { text: '#615100', background: '#F9F2D2' },
        green: { text: '#27704B', background: '#C6EED6' },
        blue: { text: '#3A669C', background: '#E0EEFF' },
        purple: { text: '#684890', background: '#EDE5FF' },
        pink: { text: '#92426E', background: '#FBDFEF' },
        red: { text: '#9B4A45', background: '#FADBDC' },
    },
};
/** `var(--cx-palette-<c>)` for a text color, `var(--cx-palette-<c>-bg)` for its background. */
export function paletteVar(color, role) {
    return `var(--cx-palette-${color}${role === 'background' ? '-bg' : ''})`;
}
//# sourceMappingURL=palette.js.map